import React, { useContext } from 'react';
import styles from './DirectoryCardArea.module.scss';
import DirectoryCard from './directory-card/DirectoryCard';
import { AppContext } from '../../context/AppContext';
import { DirectoryListType } from '../directory-list/DirectoryList';
import { DoctorIcon, HospitalIcon, PharmacyIcon, SearchIcon } from '../icons/Icons';
import { dentistIconMap } from '../../lib/initialization';

// Importing images ensures bundlers (Vite, Webpack) handle them correctly
import dentistWhite from '../../img/dentist-white.png';
import dentistBlack from '../../img/dentist-black.png';

const DirectoryCardArea = () => {
  const appContext = useContext(AppContext);
  const currentPlanUrl = window.currentPlanUrl || window.location.hostname || "agerightadvantage.com";

  const isPruittDomain = [
    "pruitthealthpremier.com",
    "pruittpremdev.wpengine.com",
    "pruittpremstg.wpengine.com",
    // "localhost:3000"
  ].some(domain => currentPlanUrl.includes(domain));

  const isAgeRightDomain = [
    "agerightadvantage.com",
    "agerighttest.wpengine.com",
    "agerightdev.wpengine.com",
  ].some(domain => currentPlanUrl.includes(domain));

  const dentistLink = isPruittDomain
    ? "https://client.libertydentalplan.com/PruittHealthPremier/FindADentist"
    : "https://www.libertydentalplan.com/Find-a-Dentist/Find-a-Dentist.aspx";

  const handleFindDrug = () => {
    // Read the current site when clicked, after initialization.
    const planSite = window.currentPlanUrl?.trim();

    if (!planSite) {
      console.error("The current plan site has not been initialized.");
      return;
    }

    // Support a domain with or without https://.
    const siteUrl = new URL(
      /^https?:\/\//i.test(planSite)
        ? planSite
        : `https://${planSite}`
    );

    const drugLink = new URL('/formulary', siteUrl.origin).href;

    window.open(drugLink, '_blank', 'noopener,noreferrer');
  };

  const useWhiteIcon = isPruittDomain || isAgeRightDomain;
  const DentistImg = useWhiteIcon ? dentistWhite : dentistBlack;

  let currentListType: DirectoryListType;
  switch (appContext.directoryListType) {
    case DirectoryListType.doctor:
    case DirectoryListType.facility:
    case DirectoryListType.pharmacy:
    case DirectoryListType.all:
      currentListType = appContext.directoryListType;
      break;
    default:
      currentListType = DirectoryListType.none;
      break;
  }

  return (
    <div className={styles.directoryCardContainer}>
      <DirectoryCard title="Find a doctor" currentListType={currentListType} listType={DirectoryListType.doctor}>
        <DoctorIcon isActive={appContext.isDirectorySelected && appContext.directoryListType === DirectoryListType.doctor} />
      </DirectoryCard>

      <DirectoryCard title="Find a hospital, facility, or other service" currentListType={currentListType} listType={DirectoryListType.facility}>
        <HospitalIcon isActive={appContext.isDirectorySelected && appContext.directoryListType === DirectoryListType.facility} />
      </DirectoryCard>

      <DirectoryCard title="Find a pharmacy" currentListType={currentListType} listType={DirectoryListType.pharmacy}>
        <PharmacyIcon isActive={appContext.isDirectorySelected && appContext.directoryListType === DirectoryListType.pharmacy} />
      </DirectoryCard>

      <DirectoryCard title="Find by name or keyword" currentListType={currentListType} listType={DirectoryListType.all}>
        <SearchIcon isActive={appContext.isDirectorySelected && appContext.directoryListType === DirectoryListType.all} />
      </DirectoryCard>

      <DirectoryCard
        title="Find a Dentist"
        currentListType={DirectoryListType.none}
        listType={DirectoryListType.none}
        // onClick={() =>
        //   window.open('https://www.libertydentalplan.com/Find-a-Dentist/Find-a-Dentist.aspx', '_blank')
        // }
        onClick={() => window.open(dentistLink, '_blank')}
      >
        <img src={DentistImg} alt="Dentist" style={{ width: '64px', height: '64px' }} />
      </DirectoryCard>
      <DirectoryCard
  title="Find a Drug"
  currentListType={DirectoryListType.none}
  listType={DirectoryListType.none}
  onClick={handleFindDrug}
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <g transform="rotate(45 32 32)">
      <rect x="20" y="8" width="24" height="48" rx="12" />
      <path d="M20 32h24" />
    </g>
  </svg>
</DirectoryCard>
    </div>
  );
};

export default DirectoryCardArea;
 